function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

    }
    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      this.size_options = this.querySelector('.product-card-sizes');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
      if (this.size_options) {
        this.enableSizeOptions();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-featured-image-link');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      images.forEach(function (image) {
        window.addEventListener('load', (event) => {
          if (!image.dataset.unveiled) {
            lazySizes.loader.unveil(image);
            image.dataset.unveiled = 'true';
          }
        });
      });

    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';
      this.color_index = this.swatches.dataset.index;

      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          if (!img.dataset.unveiled) {
            lazySizes.loader.unveil(img);
            img.dataset.unveiled = 'true';
          }
        });

        swatch.addEventListener('mouseover', () => {
          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }
          if (this.size_options) {
            this.current_options[this.color_index] = swatch.querySelector('span').innerText;
            this.updateMasterId();
          }
          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    enableSizeOptions() {
      let size_list = this.size_options.querySelectorAll('.product-card-sizes--size'),
        featured_image = this.querySelector('.product-featured-image'),
        has_hover = featured_image.classList.contains('thb-hover'),
        size_parent = this.size_options.parentElement;

      this.size_index = this.size_options.dataset.index;

      this.current_options = this.size_options.dataset.options.split(',');

      this.updateMasterId();

      size_parent.addEventListener('mouseenter', () => {
        if (has_hover) {
          featured_image.classList.remove('thb-hover');
        }
      }, {
        passive: true
      });
      size_parent.addEventListener('mouseleave', () => {
        if (has_hover) {
          featured_image.classList.add('thb-hover');
        }
      }, {
        passive: true
      });
      size_list.forEach((size) => {
        size.addEventListener('click', (evt) => {
          evt.preventDefault();

          if (size.classList.contains('is-disabled')) {
            return;
          }
          this.current_options[this.size_index] = size.querySelector('span').innerText;
          this.updateMasterId();

          size.classList.add('loading');
          size.setAttribute('aria-disabled', true);
          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            }
          };
          let formData = new FormData();

          formData.append('id', this.currentVariant.id);
          formData.append('quantity', 1);
          formData.append('sections', this.getSectionsToRender().map((section) => section.section));
          formData.append('sections_url', window.location.pathname);

          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                return;
              }
              this.renderContents(response);

              dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
              });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              size.classList.remove('loading');
              size.removeAttribute('aria-disabled');
            });
        });
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.current_options[index] === option;
        }).includes(false);
      });
      setTimeout(() => {
        this.setDisabled();
      }, 100);
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    setDisabled() {
      const variant_data = this.getVariantData();

      if (variant_data) {

        if (this.currentVariant) {
          const selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });

          const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

          const fieldset_options = Object.values(available_options)[this.size_index];
          if (fieldset_options) {
            if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
              this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        } else {
          if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
            this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
              input.classList.add('is-disabled');
            });
          }
        }

      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}


/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');

      this.onClick = (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          panel.forEach((p) => this.close_panel(e, p));
        }
      };
      // Add functionality to buttons
      this.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('panel:close', this.onClick.bind(this));
      if (!this.cc.hasAttribute('initialized')) {
        this.cc.addEventListener('click', this.onClick.bind(this));
        this.cc.setAttribute('initialized', '');
      }

    }
    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel.active');

        if (!panel) {
          return;
        }
      }
      if (panel.classList.contains('product-drawer')) {
        this.close_quick_view();
      } else if (panel.classList.contains('cart-drawer')) {
        if (panel.querySelector('.product-recommendations--full')) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.querySelector('.product-recommendations--full').classList.remove('active');
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector('.product-recommendations--full')) {
            if (!document.body.classList.contains('open-quick-view')) {
              setTimeout(() => {
                panel.classList.remove('active');
                document.body.classList.remove('open-cc');
                document.body.classList.remove('open-cart');
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          }
        }
      } else {
        panel.classList.remove('active');
        document.querySelectorAll('.header__search-bar-desktop-container, .header__search-bar-mobile-container').forEach(el => el.classList.remove('search-drawer-opened'));
        document.body.classList.remove('open-cc');
      }
    }
    close_quick_view() {
      let panel = document.getElementById('Product-Drawer');

      if (panel.querySelector('.product-quick-images--container')) {
        panel.querySelector('.product-quick-images--container').classList.remove('active');
      }
      if (window.innerWidth < 1069 || !panel.querySelector('.product-quick-images--container')) {
        panel.classList.remove('active');
        if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
          document.body.classList.remove('open-cc');
        }
        document.body.classList.remove('open-quick-view');
      } else {
        setTimeout(() => {
          panel.classList.remove('active');
          if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
            document.body.classList.remove('open-cc');
          }
          document.body.classList.remove('open-quick-view');
          panel.querySelector('#Product-Drawer-Content').innerHTML = '';
        }, 500);
      }
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {

  constructor() {
    this.container = document.getElementById('Cart-Drawer');

    if (!this.container) {
      return;
    }
    let _this = this,
      button = document.getElementById('cart-drawer-toggle'),
      quantities = this.container.querySelectorAll('.quantity input');


    // Add functionality to buttons
    button.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.add('open-cc');
      document.body.classList.add('open-cart');
      this.container.classList.add('active');
      this.container.focus();
      setTimeout(() => {
        if (this.container.querySelector('.product-recommendations--full')) {
          this.container.querySelector('.product-recommendations--full').classList.add('active');
        }
      });
      dispatchCustomEvent('cart-drawer:open');
    });

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    document.addEventListener('cart:refresh', (event) => {
      this.refresh();
    });

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));

    this.notesToggle();
    this.removeProductEvent();
    this.updateFreeShipping();
    this.errorTimerId = null;
  }
  onChange(event) {
    if (event.target.classList.contains('qty')) {
      this.updateQuantity(event.target.dataset.index, event.target.value, event);
    }
  }
  removeProductEvent() {
    let removes = this.container.querySelectorAll('.remove');

    removes.forEach((remove) => {
      if (remove.dataset.removeEventAttached){
        return;
      }
      remove.addEventListener('click', (event) => {
        event.preventDefault();
        this.updateQuantity(event.target.dataset.index, '0');
      });
      remove.dataset.removeEventAttached = true;
    });
  }
  getSectionsToRender() {
    return [{
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  notesToggle() {
    let notes_toggle = document.getElementById('order-note-toggle');

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener('click', (event) => {
      notes_toggle.nextElementSibling.classList.add('active');
    });
    notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
      el.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.remove('active');
        this.saveNotes();
      });
    });
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('mini-cart__notes').value
      })
    });
  }
  updateFreeShipping() {
    const free_shipping = this.container.querySelector('.free-shipping');

    if (free_shipping) {
      let amount_text = free_shipping.querySelector('.free-shipping--text span');
      let total = parseInt(free_shipping.dataset.cartTotal, 10);
      let minimum = Math.round(parseInt(free_shipping.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      let percentage = 1;

      if (total < minimum) {
        percentage = total / minimum;

        if (amount_text) {
          let remaining = minimum - total,
            format = window.theme.settings.money_with_currency_format || "${{amount}}";
          amount_text.innerHTML = formatMoney(remaining, format);
        }
      }

      free_shipping.style.setProperty('--percentage', percentage);
    }
  }
  updateQuantity(line, quantity, event) {
    if (this.errorTimerId){
      clearTimeout(this.errorTimerId);
    }
    const lineItemEl = this.container.querySelector(`#CartDrawerItem-${line}`);
    const lineItemElErrorEl = lineItemEl.querySelector('.product-cart-item__error');
    lineItemEl?.classList.add('thb-loading');
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
    });

    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });
    if (this.container.querySelector('.product-recommendations--full')) {
      this.container.querySelector('.product-recommendations--full').classList.remove('active');
    }
    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      ...{
        body
      }
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          if (parsedState.sections) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));

        this.removeProductEvent();
        this.notesToggle();
        this.updateFreeShipping();
        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });

        function removeCartErrorEl() {
          const el = lineItemElErrorEl;
          if (!el.classList.contains('product-cart-item__error--active')) return;
          el.classList.add('product-cart-item__error--closing');
          el.addEventListener('transitionend', function handler() {
            el.classList.remove('product-cart-item__error--active', 'product-cart-item__error--closing');
            el.textContent = "";
            el.removeEventListener('transitionend', handler);
          });
        }

        if (parsedState.errors){
          if (event.target.classList.contains("qty")){
            const max = parseInt(event.target.max);
            const qty = parseInt(quantity)
            if (qty > max){
              event.target.value = max;
            }
          }
          lineItemElErrorEl.textContent = parsedState.errors;
          lineItemElErrorEl.classList.add('product-cart-item__error--active');
          this.errorTimerId = setTimeout(function(){
            removeCartErrorEl(lineItemElErrorEl);
          }, 3000);
        }else{
          removeCartErrorEl();
        }

        if (this.container.querySelector(`#CartDrawerItem-${line}`)) {
          this.container.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
        }
      });
  }
  refresh() {
    if (this.container.querySelector('.product-recommendations--full')) {
      this.container.querySelector('.product-recommendations--full').classList.remove('active');
    }
    let sections = 'cart-drawer,cart-bubble';
    fetch(`${window.location.pathname}?sections=${sections}`)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
        }));

        this.removeProductEvent();
        this.notesToggle();
        this.updateFreeShipping();
      });
  }
}

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select'),
      offset = 13;
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);
    if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));

    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add('open-cc');
        this.body.classList.add('open-quick-view');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        setTimeout(() => {
          this.drawer.querySelector('.product-quick-images--container').classList.add('active');
        });
        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary')?.addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof CartDrawer !== 'undefined') {
    new CartDrawer();
  }
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});



// notify me modal code

class NotifyMeButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const container = this.closest('.product-add-to-cart-container') ||
                        this.closest('.product-form') ||
                        this.closest('.thb-product-detail') ||
                        this.closest('#Product-Drawer-Content') ||
                        document;
      const modal = container.querySelector('#notify__master') || document.getElementById('notify__master');
      if (modal) {
        modal.style.display = 'block';
      }
    });
  }
}

customElements.define('notify-me-button', NotifyMeButton);



class NotifyMe extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initEventListeners();
    }

    initEventListeners() {
        const closeModal = this.querySelector('.close');
        const notifyButton = this.querySelector('#notify__button');

        if (closeModal) {
            closeModal.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.closeModal();
            });
        }

        this.addEventListener('click', (e) => {
            if (e.target === this) {
                this.closeModal();
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.style.display === 'block') {
                this.closeModal();
            }
        });

        if (notifyButton) {
            notifyButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.notifyOnWhatsApp();
            });
        }
    }

    closeModal() {
        this.style.display = 'none';
    }

    notifyOnWhatsApp() {
        const info = this.querySelector('#notify__text');
        const productId = info?.getAttribute('data-productId');
        const productTitle = info?.getAttribute('data-productTitle');
        const currentVariantId = this.querySelector('#variant_id')?.value || document.querySelector('[name="id"]')?.value || '';
        const nationalCode = this.querySelector('#countryCode');
        const domain = window.location.hostname;
        
        if (info?.value) {
            const data = {
                phone: (nationalCode?.value || '91') + info.value.trim(),
                variant_id: currentVariantId,
                product_id: productId,
                product_title: productTitle,
                variant_url: window.location.href
            };

            alert('Thanks for subscribing to the WhatsApp notification');
            this.closeModal();
            this.makeXhr(
                'POST',
                'https://iy08ni8pq5.execute-api.ap-south-1.amazonaws.com/api/notify/api',
                data,
                domain
            );
        } else {
            alert('Please provide the phone number');
        }
    }

    makeXhr(method, url, data, domain) {
        const xhttp = new XMLHttpRequest();
        xhttp.open(method, url, true);
        xhttp.setRequestHeader('Content-type', 'application/json');
        xhttp.setRequestHeader('x-shopify-shop-domain', domain);

        xhttp.onload = () => {
            if (xhttp.status >= 200 && xhttp.status < 300) {
                console.log('Request successful:', xhttp.response);
            } else {
                console.error('Request failed:', xhttp.status, xhttp.statusText);
            }
        };

        xhttp.onerror = () => {
            console.error('Network error or CORS issue occurred.');
        };

        xhttp.send(data ? JSON.stringify(data) : null);
    }
}

customElements.define("notify-me", NotifyMe);

// dc whatsapp notification

document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("notify__master_dc");
  if (!modal) return; 

  document.body.addEventListener("click", (event) => {
    if (event.target.closest(".notify-me-button_dc")) {
      event.preventDefault();
      event.stopPropagation();
      modal.style.display = "block";
    }   
    if (
      event.target.closest(".close") ||
      event.target.closest(".nfdc") ||
      event.target === modal
    ) {
      modal.style.display = "none";
    }
  });
});

class NotifyMeDC extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initEventListeners();
    }

    initEventListeners() {
        const closeModal = this.querySelector('.close');
        const notifyButton = this.querySelector('#notify__button');

        if (closeModal) {
            closeModal.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.closeModal();
            });
        }

        this.addEventListener('click', (e) => {
            if (e.target === this) {
                this.closeModal();
            }
        });

        if (notifyButton) {
            notifyButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.notifyOnWhatsApp();
            });
        }
    }

    closeModal() {
        this.style.display = 'none';
    }

    async notifyOnWhatsApp() {
        const info = this.querySelector('#notify__text');
        const nationalCode = this.querySelector('#countryCode');

        if (info?.value) {
            const data = {
                phone: (nationalCode?.value || '91') + info.value.trim(),
                variant_id: "StevenRhodes",
                product_id: window.location.href,
                variant_url: new Date().toISOString()
            };

            console.log("Sending data:", data);
            alert('Thanks for subscribing to WhatsApp notifications');
            this.closeModal();
            const webAppUrl = "https://script.google.com/macros/s/AKfycbxLPk-ucRhLZwPwHhUCUxJcc0w0DX0BAewRCjpYZCRSJMEfZGJ-AziEj33f9zOwd1sWpQ/exec";

            try {
                const response = await fetch(webAppUrl, {
                    method: 'POST',
                    mode: 'no-cors',
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json"
                    },
                    body: JSON.stringify(data)
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                console.log("Response:", result);
            } catch (error) {
                console.error("Error sending request:", error);
            }
        } else {
            alert('Please provide the phone number');
        }
    }
}

customElements.define("notify-me-dc", NotifyMeDC);




class FacetsTabs extends HTMLElement {
   constructor() {
         super();
         this._onTitleClick = this._onTitleClick.bind(this);
         this._selectedIndex = 0;
         this._observer = null;
     }

     connectedCallback() {
         this.init();
         this._setupObserver?.();
     }

     disconnectedCallback() {
         this.cleanupEventListeners();
         if (this._observer) {
             this._observer.disconnect();
             this._observer = null;
         }
     }

     init() {
         this.filterTitles = Array.from(this.querySelectorAll('.thb-filter-title'));
         this.filterContents = Array.from(this.querySelectorAll('.thb-filter-content'));

         if (!this.filterTitles.length || !this.filterContents.length) {
             console.error('FacetsTabs: Missing required child elements');
             return;
         }
         if (this._selectedIndex >= this.filterTitles.length) {
             this._selectedIndex = 0;
         }

         this.setupEventListeners();
         this.updateUI();
     }
    setupEventListeners() {
        this.cleanupEventListeners();
        this.filterTitles.forEach((title) => title.addEventListener('click', this._onTitleClick));
    }

    cleanupEventListeners() {
        if (this.filterTitles) {
            this.filterTitles.forEach((title) => title.removeEventListener('click', this._onTitleClick));
        }
    }

    updateUI() {
        this.filterTitles.forEach((title, index) => title.classList.toggle('active', index === this._selectedIndex));
        this.filterContents.forEach((content, index) => {
            content.classList.toggle('show', index === this._selectedIndex);
            content.classList.toggle('hide', index !== this._selectedIndex);
        });
    }

    _onTitleClick(event) {
        const newIndex = this.filterTitles.indexOf(event.currentTarget);
        if (newIndex !== -1 && newIndex !== this._selectedIndex) {
            this._selectedIndex = newIndex;
            this.updateUI();
        }
    }
}

customElements.define('facets-tabs', FacetsTabs);


const observer = new MutationObserver(() => {
    document.querySelector('facets-tabs')?.init();
});

const container = document.querySelector('.side-panel-content');
if (container) {
    observer.observe(container, { childList: true, subtree: true });
}





document.addEventListener("DOMContentLoaded", function () {
    function hideWishlistSvgs() {
        const svgIcons = document.querySelectorAll('[class*="CollectionPageAddToWishList_flits_wls_icon_svg_color_"]');
        svgIcons.forEach(icon => {
            icon.style.display = 'none';
        });
    }

    hideWishlistSvgs();

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'childList' || mutation.type === 'attributes') {
                hideWishlistSvgs();
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true
    });

    const wishlistButtons = document.querySelectorAll('a.icon-wishlist-heart-empty.wishlist-btn.grid-wishlist-btn.heart-wishlist-animation.style_1');
    wishlistButtons.forEach(button => {
        button.addEventListener('mouseover', hideWishlistSvgs);
        button.addEventListener('mouseenter', hideWishlistSvgs);
    });
});

(() => {
  const COMPONENT_NAME = 'floating-video';
  const SESSION_KEY = 'floatingVideoClosed';

  if (customElements.get(COMPONENT_NAME)) return;

  class FloatingVideo extends HTMLElement {
    constructor() {
      super();
      this._onCloseClick = this._onCloseClick.bind(this);
    }

    connectedCallback() {
      // Prevent double init if reconnected
      if (this._initialized) return;
      this._initialized = true;

      // If already closed in this tab, remove immediately
      // try {
      //   if (sessionStorage.getItem(SESSION_KEY) === 'true') {
      //     this.remove();
      //     return;
      //   }
      // } catch (_) {}

      this._closeButton = this.querySelector('[data-floating-video-close]');
      if (!this._closeButton) return;

      this._closeButton.addEventListener('click', this._onCloseClick);
    }

    disconnectedCallback() {
      if (!this._closeButton) return;

      this._closeButton.removeEventListener('click', this._onCloseClick);
      this._initialized = false;
    }

    _onCloseClick(event) {
      event.preventDefault();

      // try {
      //   sessionStorage.setItem(SESSION_KEY, 'true');
      // } catch (_) {}

      this.remove();
    }
  }

  customElements.define(COMPONENT_NAME, FloatingVideo);
})();

(function () {
  'use strict';

  const searchBar = document.querySelector('.header__search-bar-mobile-container');
  if (!searchBar) return;

  const MIN_DELTA = 12;
  const DESKTOP_BREAKPOINT = 1024;
  const TOP_THRESHOLD = 100;
  const DEBOUNCE_TIME = 100;

  let lastScrollY =
    window.pageYOffset || document.documentElement.scrollTop || 0;

  let lastState = null;
  let ticking = false;
  let lastToggleTime = 0;

  function isMobile() {
    return window.innerWidth < DESKTOP_BREAKPOINT;
  }

  function showSearchBar() {
    const now = Date.now();

    if (lastState !== 'revealed' && now - lastToggleTime > DEBOUNCE_TIME) {
      searchBar.classList.add('revealed');
      searchBar.setAttribute('aria-hidden', 'false');
      lastState = 'revealed';
      lastToggleTime = now;
    }
  }

  function hideSearchBar() {
    const now = Date.now();

    if (lastState !== 'hidden' && now - lastToggleTime > DEBOUNCE_TIME) {
      searchBar.classList.remove('revealed');
      searchBar.setAttribute('aria-hidden', 'true');
      lastState = 'hidden';
      lastToggleTime = now;
    }
  }

  function updateLastScroll() {
    lastScrollY =
      window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function handleScrollFrame() {
    if (!isMobile()) {
      hideSearchBar();
      ticking = false;
      return;
    }

    const currentY =
      window.pageYOffset || document.documentElement.scrollTop || 0;

    const delta = currentY - lastScrollY;

    if (currentY < TOP_THRESHOLD) {
      showSearchBar();
      lastScrollY = currentY;
      ticking = false;
      return;
    }

    if (Math.abs(delta) > MIN_DELTA) {
      if (delta < 0) {
        showSearchBar();
      } else {
        hideSearchBar();
      }
      lastScrollY = currentY;
    }

    ticking = false;
  }

  function handleScroll() {
    if (!ticking) {
      window.requestAnimationFrame(handleScrollFrame);
      ticking = true;
    }
  }

  function initState() {
    const currentY =
      window.pageYOffset || document.documentElement.scrollTop || 0;

    if (currentY < TOP_THRESHOLD) {
      showSearchBar();
    } else {
      hideSearchBar();
    }

    lastScrollY = currentY;
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('touchstart', updateLastScroll, { passive: true });
  window.addEventListener('touchend', updateLastScroll, { passive: true });

  let resizeTimeout = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      if (!isMobile()) {
        hideSearchBar();
      } else {
        updateLastScroll();
      }
    }, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initState);
  } else {
    initState();
  }

  window.addEventListener('load', initState);
})();


class GetProductSizeLabel extends HTMLElement {
  constructor() {
    super();
    this.sizeMap = {};      // Stores ALL sizes
    this.hasLoaded = false; // Prevent multiple fetches
    this.handleVariantChange = this.handleVariantChange.bind(this);
  }

  static get observedAttributes() {
    return ['data-selected-size'];
  }

  connectedCallback() {
    document.addEventListener('variant-changed', this.handleVariantChange);
    this.init();
  }

  disconnectedCallback() {
    document.removeEventListener('variant-changed', this.handleVariantChange);
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (name === 'data-selected-size' && oldVal !== newVal) {
      this.renderForSize(newVal);
    }
  }

  init() {
    if (this.hasLoaded) return;

    // Read size chart data from the embedded <template> element
    // This follows the same pattern as the sizing guide modal —
    // the content is rendered server-side via Liquid using
    // product.metafields.custom.page_size_chart.value.content
    const template = this.querySelector('template.size-chart-data');
    if (!template) return;

    const content = template.content;
    const tables = content.querySelectorAll('table');
    if (tables.length === 0) return;

    this.sizeMap = this.parseAllSizes(content);
    this.hasLoaded = true;

    // Initial render
    const initialSize = this.dataset.selectedSize;
    if (initialSize) {
      this.renderForSize(initialSize.trim().toUpperCase());
    }
  }

  handleVariantChange(event) {
    if (!event?.detail?.selected_value) return;

    const newSize = event.detail.selected_value.trim().toUpperCase();
    this.setAttribute('data-selected-size', newSize);
  }

  parseAllSizes(doc) {
    const map = {};
    const tables = doc.querySelectorAll('table');

    tables.forEach(table => {
      const rows = Array.from(table.querySelectorAll('tr'));
      let activeSection = null;

      rows.forEach(row => {
        const ths = row.querySelectorAll('th');
        const tds = row.querySelectorAll('td');

        // Detect SIZE header row — support both <th> and <td> headers
        if (row.textContent.toUpperCase().includes('SIZE')) {
          const headerCells = ths.length ? ths : tds;
          if (headerCells.length > 0) {
            const headers = Array.from(headerCells).map(cell =>
              cell.textContent.trim().toUpperCase()
            );

            // Only treat as header row if first cell contains SIZE
            if (headers[0] === 'SIZE') {
              activeSection = { headers };
              return;
            }
          }
        }

        if (!activeSection || !tds.length) return;

        const label = tds[0].textContent.trim().toUpperCase();

        activeSection.headers.forEach((size, index) => {
          if (index === 0) return; // skip "SIZE" column

          const valueCell = tds[index];
          if (!valueCell) return;

          const value = valueCell.textContent.trim();
          if (!value) return;

          if (!map[size]) {
            map[size] = { top: {}, bottom: {} };
          }

          if (label === 'CHEST') {
            map[size].top.CHEST = value;
          }

          if (label === 'WAIST') {
            map[size].bottom.WAIST = value;
          }

          if (label === 'LENGTH') {
            // LENGTH belongs to the current section
            if (map[size].top.CHEST && !map[size].top.LENGTH) {
              map[size].top.LENGTH = value;
            } else {
              map[size].bottom.LENGTH = value;
            }
          }
        });
      });
    });

    return map;
  }

  /**
   * UAE display logic:
   * - Both chest & waist → [top-icon] Chest XX inches | [bottom-icon] Waist XX inches
   * - Chest only → [top-icon] Chest XX inches | Length XX inches
   * - Waist only → [bottom-icon] Waist XX inches | Length XX inches
   */
  renderForSize(size) {
    const container = this.querySelector('.size-label-inline');
    if (!container) return;

    if (!this.sizeMap || !this.sizeMap[size]) {
      container.style.display = 'none';
      return;
    }

    const data = this.sizeMap[size];
    const hasChest = !!data.top?.CHEST;
    const hasWaist = !!data.bottom?.WAIST;

    if (!hasChest && !hasWaist) {
      container.style.display = 'none';
      return;
    }

    const primarySlot = container.querySelector('.size-label-slot--primary');
    const secondarySlot = container.querySelector('.size-label-slot--secondary');
    const divider = container.querySelector('.size-label-divider');

    if (hasChest && hasWaist) {
      // Both → Chest | Waist (no length)
      this.setSlot(primarySlot, 'top', 'Chest', `${data.top.CHEST} inches`);
      this.setSlot(secondarySlot, 'bottom', 'Waist', `${data.bottom.WAIST} inches`);
      if (divider) divider.style.display = '';
    } else if (hasChest) {
      // Chest only → Chest | Length
      this.setSlot(primarySlot, 'top', 'Chest', `${data.top.CHEST} inches`);
      if (data.top.LENGTH) {
        this.setSlot(secondarySlot, null, 'Length', `${data.top.LENGTH} inches`);
        if (divider) divider.style.display = '';
      } else {
        if (secondarySlot) secondarySlot.style.display = 'none';
        if (divider) divider.style.display = 'none';
      }
    } else if (hasWaist) {
      // Waist only → Waist | Length
      this.setSlot(primarySlot, 'bottom', 'Waist', `${data.bottom.WAIST} inches`);
      if (data.bottom.LENGTH) {
        this.setSlot(secondarySlot, null, 'Length', `${data.bottom.LENGTH} inches`);
        if (divider) divider.style.display = '';
      } else {
        if (secondarySlot) secondarySlot.style.display = 'none';
        if (divider) divider.style.display = 'none';
      }
    }

    container.style.display = 'flex';
  }

  /**
   * Sets a slot's icon and text.
   * @param {Element} slot - The slot element
   * @param {string|null} iconType - 'top', 'bottom', or null (hide all icons)
   * @param {string} label - The label (e.g. 'Chest')
   * @param {string} value - The value (e.g. '30-32 inches')
   */
  setSlot(slot, iconType, label, value) {
    if (!slot) return;
    slot.style.display = '';

    const topIcon = slot.querySelector('.size-label-slot__icon--top');
    const bottomIcon = slot.querySelector('.size-label-slot__icon--bottom');
    const textEl = slot.querySelector('.size-label-slot__text');

    if (topIcon) topIcon.style.display = iconType === 'top' ? '' : 'none';
    if (bottomIcon) bottomIcon.style.display = iconType === 'bottom' ? '' : 'none';
    if (textEl) textEl.innerHTML = `<span class="size-label-name">${label}</span> <span class="size-label-value">${value}</span>`;
  }

  hideAll() {
    const container = this.querySelector('.size-label-inline');
    if (container) container.style.display = 'none';
  }

  safeSetText(selector, value) {
    const el = this.querySelector(selector);
    if (el) el.textContent = value;
  }
}

if (!customElements.get('get-product-size-label')) {
  customElements.define('get-product-size-label', GetProductSizeLabel);
}
